import { useSelector } from "react-redux";
import { createContext, useState, useMemo } from "react";
import {
    // StaticMetric,
    StaticValues,
    StaticMetricView,
} from "../../../components/report_fragments/StaticMetrics";
import OutstandingWIP from "../../../components/report_fragments/OutstandingWIP";

import { db } from "../../../utils/indexeddb/db";
import { useLiveQuery } from "dexie-react-hooks";
import { DataViewTable } from "../../../components/visualizations/Tables";
import { DoubleWIP } from "../../../components/report_fragments/WIPCharts";
import GridLoader from "react-spinners/GridLoader";

export const StaticWIPContext = createContext(null);

function WIPfragment(filter, titleHead, type) {
    const [staticWIP, setStaticWIP] = useState([]);
    const staticData = StaticValues(staticWIP, "WIPOUTSTANDING");

    return (
        // <StaticWIPContext.Provider value={{staticWIP: staticWIP, setStaticWIP: setStaticWIP, staticWIPvalue: staticWIPvalue}}>
        <div className="content-area">
            {/* <StaticMetric id="StaticWIP" query={static_query} objKey='wipRespStatic' header={titleHead}/> */}
            <StaticMetricView label="WIP" data={staticData} header={titleHead} />
            <OutstandingWIP
                // query={unpaid_query}
                type={type}
                filter={filter}
                header="Responsible"
                onChange={setStaticWIP}
            />
        </div>
        // </ StaticWIPContext.Provider>
    );
}

export function RespWIP() {
    const user = useSelector((state) => state.user);
    const { STAFFINDEX, RESPONSIBLE_AR } = user;
    const apiRoot = useSelector(state => state.globals.apiRoot)

    document.title = `Magnify | Client Responsible WIP`;

    if (RESPONSIBLE_AR === 1) {
        const static_query = `${apiRoot}/api/wip/static/responsible/${STAFFINDEX}`;
        const unpaid_query = `${apiRoot}/api/wip/outstanding/responsible/${STAFFINDEX}`;
        // const static_query = `${apiRoot}/api/ar/static/responsible/27`
        // const unpaid_query = `${apiRoot}/api/ar/unpaid/responsible/27`

        return WIPfragment(STAFFINDEX, "My WIP", "responsible");
    } else {
        return <div>Sorry, you don't have access to this report</div>;
    }
}

export function DeptWIP() {
    const user = useSelector((state) => state.user);
    const { DEPT_WIP, DEPARTMENT } = user;

    document.title = `Magnify | ${DEPARTMENT} Department WIP`;

    if (DEPT_WIP === 1) {
        return WIPfragment(DEPARTMENT, `${DEPARTMENT} WIP`, "department");
    } else {
        return <div>Sorry, you don't have access to this report</div>;
    }
}

export function TeamWIP() {
    const user = useSelector((state) => state.user);

    const { TEAM_WIP, HOMEROOM } = user;

    document.title = `Magnify | ${HOMEROOM} Team WIP`;

    if (TEAM_WIP === 1) {
        return WIPfragment(HOMEROOM, `Homeroom WIP`, "team");
    } else {
        return <div>Sorry, you don't have access to this report</div>;
    }
}

export function MyResponsibleWIP() {
    const user = useSelector(state => state.user)
    
    const respData = useLiveQuery(async () => {
        const all_wip = await db.WIP.toArray()
        const job_wip = all_wip.filter(wip => wip.JOB_PARTNER === user.EMPLOYEE || wip.JOB_MANAGER === user.EMPLOYEE)
        const client_wip = all_wip.filter(wip => wip.CLIENT_PARTNER === user.EMPLOYEE || wip.CLIENT_MANAGER === user.EMPLOYEE)

        return { all_wip: all_wip, client_wip: client_wip, job_wip: job_wip }
    })

    const lists = useMemo(() => ({
        CLIENT: [...new Set(respData?.all_wip?.map(item => item.CLIENT) || [])].sort((a, b) => a.localeCompare(b)),
        CLIENT_PARTNER: [...new Set(respData?.all_wip?.map(item => item.CLIENT_PARTNER) || [])].sort((a, b) => a.localeCompare(b)),
        CLIENT_MANAGER: [...new Set(respData?.all_wip?.map(item => item.CLIENT_MANAGER) || [])].sort((a, b) => a.localeCompare(b)),
        JOB_NAME: [...new Set(respData?.all_wip?.map(item => item.JOB_NAME) || [])].sort((a, b) => a.localeCompare(b)),
        JOB_PARTNER: [...new Set(respData?.all_wip?.map(item => item.JOB_PARTNER) || [])].sort((a, b) => a.localeCompare(b)),
        JOB_MANAGER: [...new Set(respData?.all_wip?.map(item => item.JOB_MANAGER) || [])].sort((a, b) => a.localeCompare(b)),
        OUTSTANDING_WIP: null
    }), [respData?.all_wip]);

    if (respData && 'all_wip' in respData && 'client_wip' in respData && 'job_wip' in respData) {
        return (
            <section>
                <DoubleWIP 
                    left_data={respData.client_wip} 
                    left_header={"My Client Responsible WIP"} 
                    right_data={respData.job_wip} 
                    right_header={'My Job Responsible WIP'} 
                    label={"My Total Responsible"} 
                    data={respData.all_wip}
                />
                <section className="data-view-table">
                    <DataViewTable
                        data={respData.all_wip}
                        columnList={lists}
                        scrollHeight="45vh"
                        onChange={() => true}
                    />
                </section>
            </section>
        )
    } else {
        return (
            <GridLoader />
        )
    }
}
